import React from "react";
import Field from "@/components/post-ad/Field";
import { POST } from "@/constants/testIds";

/**
 * Primary buyer-facing contact — phone + WhatsApp. Owner email is already
 * on the account so we never re-collect it here.
 */
export default function PrimaryContactSection({ form, set }) {
  return (
    <div className="grid md:grid-cols-2 gap-4">
      <Field label="Phone (optional)">
        <input
          data-testid={POST.phone}
          value={form.phone}
          onChange={(e) => set({ phone: e.target.value })}
          className="input"
          placeholder="+64 21 xxx xxxx"
        />
      </Field>
      <Field label="WhatsApp (optional)">
        <input
          data-testid={POST.whatsapp}
          value={form.whatsapp}
          onChange={(e) => set({ whatsapp: e.target.value })}
          className="input"
          placeholder="+64 21 xxx xxxx"
        />
      </Field>
    </div>
  );
}
